const AirQualityParameters = {

  TEMP: {
    key: 'TEMP',
    name: 'Temperature',
    markup: 'Temperature',
    default_value: 0,
    unit: '°C',
    unicode: {
      markup: 'Temperature',
      unit: '°C'
    }
  },
  PM10: {
    key: 'PM10',
    name:'Particulate Matter (Dust) of 10 micron diameter or smaller',
    markup: 'PM<sub>10</sub>',
    default_value: 0,
    unit: 'µg/m<sup>3</sup>',
    unicode: {
      markup: 'PM₁₀',
      unit: 'µg/m³'
    }
  },
  PM2_5: {
    key: 'PM2_5',
    name:'Particulate Matter (Dust) of 2.5 micron diameter or smaller',
    markup: 'PM<sub>2.5</sub>',
    default_value: 0,
    unit: 'µg/m<sup>3</sup>',
    unicode: {
      markup: 'PM₂.₅',
      unit: 'µg/m³'
    }
  },
  RSPM: {
    key: 'RSPM',
    name:'Respirable Suspended Particulate Matter',
    markup: 'RSPM',
    default_value: 0,
    unit: 'µg/m<sup>3</sup>',
    unicode: {
      markup: 'RSPM',
      unit: 'µg/m³'
    }
  },
  SPM: {
    key: 'SPM',
    name:'Suspended Particulate Matter',
    markup: 'SPM',
    default_value: 0,
    unit: 'µg/m<sup>3</sup>',
    unicode: {
      markup: 'SPM',
      unit: 'µg/m³'
    }
  },
  HUM: {
    key: 'HUM',
    name:'Humidity',
    markup: 'Humidity',
    default_value: 0,
    unit: '%',
    unicode: {
      markup: 'Humidity',
      unit: '%'
    }
  },
  CO: {
    key: 'CO',
    name:'Carbon Monoxide',
    markup: 'CO',
    default_value: 0,
    unit: 'µg/m<sup>3</sup>',
    unicode: {
      markup: 'CO',
      unit: 'µg/m³'
    }
  },
  O3: {
    key: 'O3',
    name:'Ozone',
    markup: 'O<sub>3</sub>',
    default_value: 0,
    unit: 'µg/m<sup>3</sup>',
    unicode: {
      markup: 'O³',
      unit: 'µg/m³'
    }
  },
  NO2: {
    key: 'NO2',
    name:'Nitrogen Dioxide',
    markup: 'NO<sub>2</sub>',
    default_value: 0,
    unit: 'µg/m<sup>3</sup>',
    unicode: {
      markup: 'NO₂',
      unit: 'µg/m³'
    }
  },
  H2S: {
    key: 'H2S',
    name:'Hydrogen Sulphide',
    markup: 'H<sub>2</sub>S',
    default_value: 0,
    unit: 'µg/m<sup>3</sup>',
    unicode: {
      markup: 'H₂S',
      unit: 'µg/m³'
    }
  },
  SO2: {
    key: 'SO2',
    name:'Sulphur Dioxide',
    markup: 'SO<sub>2</sub>',
    default_value: 0,
    unit: 'µg/m<sup>3</sup>',
    unicode: {
      markup: 'SO₂',
      unit: 'µg/m³'
    }
  }
};

export default AirQualityParameters;



// WEBPACK FOOTER //
// ./src/models/data/airQuality/AirQualityParameters.js